import api from "api"
import { SetupHouseholdModal } from "components/accounts/SetupHouseholdModal"
import AccountsConnector from "components/accounts/AccountsConnector"
import FaqLinks from "components/FaqLinks"
import React, { useState, useEffect } from "react"
import { Link, Redirect } from "react-router-dom"
import { Button, Container, Grid, Icon } from "semantic-ui-react"
import { useStore } from "store"

const AddFirstAccountForm = props => {
  const { household, baseUrl, householdState } = props

  const [showAccountsConnector, setShowAccountsConnector] = useState(false)
  const [accountsucceeded, setAccountsSucceeded] = useState(false)
  const [isRefreshingAccounts, setIsRefreshingAccounts] = useState(
    householdState.isRefreshingAccounts
  )

  const {
    updateHouseholdState,
    updateHouseholdConnectionsRefreshStatus
  } = useStore()

  useEffect(() => {
    if (isRefreshingAccounts && !householdState.isRefreshingAccounts) {
      setIsRefreshingAccounts(householdState.isRefreshingAccounts)
      setAccountsSucceeded(true)
    }
  }, [householdState, isRefreshingAccounts])

  if (accountsucceeded) {
    return <Redirect to="/organize/accounts+property" />
  } else {
    return (
      <div>
        {showAccountsConnector ? (
          <AccountsConnector
            getFastLink={messageId =>
              `${api.baseURL}households/${household.id}/connections/linker?${messageId}`
            }
            household={household}
            onSuccess={async () => {
              await updateHouseholdConnectionsRefreshStatus(household.id)
              await updateHouseholdState({
                id: household.id,
                isRefreshingAccounts: true,
                refreshingConnectingIds: []
              })
              setShowAccountsConnector(false)
            }}
            onFailure={() => {
              setShowAccountsConnector(false)
            }}
          />
        ) : null}
        <div className="AddFirstAccountForm">
          {householdState["isRefreshingAccounts"] ? (
            <Button icon labelPosition="right" primary disabled>
              Linking First Accounts...
              <Icon loading name="refresh" />
            </Button>
          ) : (
            <>
              <Button primary onClick={() => setShowAccountsConnector(true)}>
                Link Account
              </Button>
              <Button primary>
                <Link
                  to={`${baseUrl}/accounts/new`}
                  className="navlink"
                  style={{ color: "white" }}
                  data-testid="addAccountManually"
                >
                  Add Manually
                </Link>
              </Button>
            </>
          )}

          {householdState["isRefreshingAccounts"] ? (
            <p style={{ paddingTop: "0.5em" }} className="greyed-text">
              Hold tight while we pull in your data.
            </p>
          ) : null}
        </div>
      </div>
    )
  }
}

const AddFirstAccount = ({ baseUrl, household, faqLinks }) => {
  const [householdState] = useStore("householdState", household.id)
  return (
    <div>
      <AddFirstAccountForm
        baseUrl={baseUrl}
        householdState={householdState}
        household={household}
      />
      <Grid centered>
        <Grid.Column width={6}>
          <p className="greyed-text">
            We take the privacy of your data seriously by limiting what we
            collect and protecting it with multiple layers of security,
            employing rigorous encryption and access controls.
          </p>
        </Grid.Column>
        <Grid.Column width={6}>
          <FaqLinks items={faqLinks} />
        </Grid.Column>
      </Grid>
      {householdState["isRefreshingAccounts"] ? null : (
        <div className="AddFirstAccount__BackLink">
          <Link
            to={`/${baseUrl.split("/")[1]}/introduction`}
            className="navlink"
          >
            <Icon name="chevron left" size="small" />
            back to introduction
          </Link>
        </div>
      )}
    </div>
  )
}

const AddFirstAccountContainer = props => {
  const [showHouseholdModal, setShowHouseholdModal] = useState(
    props.people.length === 0
  )
  const [{ label, description, faqs }] = useStore(
    "contextuals",
    `Screen: addfirst`
  )

  const onHouseHoldModalSubmit = values => {
    const { setupNewHousehold } = props
    setupNewHousehold({
      household_id: props.household.id,
      ...values
    }).then(
      () => {
        setShowHouseholdModal(false)
        window.trackEvent("setup-household")
      },
      error => {
        throw error
      }
    )
  }

  const handleOnCancel = () => setShowHouseholdModal(false)

  return (
    <Container textAlign="center" className="EmptyAccountsAndPropertyView">
      {showHouseholdModal && (
        <SetupHouseholdModal
          values={{
            primary_state_of_residence:
              props.household.primary_state_of_residence,
            first_name: props.user.first_name
          }}
          submit={onHouseHoldModalSubmit}
          onCancel={handleOnCancel}
        />
      )}
      <Grid centered>
        <Grid.Row>
          <Grid.Column textAlign="center">
            <h2 className="EmptyAccountsAndProperty__Heading">{label}</h2>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column
            className="EmptyAccountsAndProperty__Description"
            width={12}
            textAlign="center"
          >
            <p>{description}</p>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row centered>
          <Grid.Column textAlign="center">
            <AddFirstAccount
              baseUrl={props.baseUrl}
              household={props.household}
              faqLinks={faqs}
              onNextClick={props.onNextClick}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  )
}

export const EmptyStateView = ({ household, baseUrl, user }) => {
  const [peopleObject] = useStore("householdPeople", household.id)
  const people = Object.keys(peopleObject)
  const { setupNewHousehold } = useStore()
  return (
    <AddFirstAccountContainer
      household={household}
      setupNewHousehold={setupNewHousehold}
      people={people}
      baseUrl={baseUrl}
      user={user}
    />
  )
}
